export const generateCSVData = (): string[][] => {
    return [
        ['BATCH NUMBER', 'SERIAL NUMBER PREFIX', 'RANGE_FROM', 'PLATE COUNT', 'PLATE_TYPE', 'EXPIRY DATE', 'MANUFACTURING DATE', 'MANUFACTURER DETAILS'],
        ['B10001', 'MPATS PL', '277', '5', '90mm', '13-09-2024', '01-12-2023', 'Sample'],
        ['B10001', 'MPATS PL', '278', '5', '90mm', '13-09-2024', '01-12-2023', 'Sample']
    ];
};

